import { useState, useCallback } from 'react'

export function useTheme() {
  const [isDark, setIsDark] = useState(() => {
    return document.documentElement.getAttribute('data-theme') !== 'light'
  })

  const toggle = useCallback(() => {
    const html = document.documentElement
    const next = html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark'
    html.setAttribute('data-theme', next)
    localStorage.setItem('cs-theme', next)
    setIsDark(next === 'dark' || next !== 'light')
  }, [])

  return { isDark, toggle }
}
